<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="title" [breadcrumb]="''" [count]="count" icon="fa-cog">
</app-breadcrumb>
<div class="content-background">
  <div class="row">
    <div class="col-sm-12">
      <div class="inputWithIcon inputWithIcon-search float-right d-flex">
        <app-advanced-mode id="insurerGridAdvancedSwitch" [storageKey]="'insurer-list'"
          (collapsibleToggle)="enableAdvanced=$event">
        </app-advanced-mode>
        <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
          (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
        <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <kendo-grid [data]="view.gridData" [loading]="view.loading" [navigable]="true"
      [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
      [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort"
      [filterable]="enableAdvanced" [filter]="view.state.filter" [groupable]="enableAdvanced" [group]="view.groups"
      [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
      (groupChange)="groupChange($event)" (dataStateChange)="dataStateChange($event)">
      <kendo-grid-messages noRecords="{{ 'NO-INSURERS' | translate }}">
      </kendo-grid-messages>
      <kendo-grid-column field="name" [width]="50" title="{{ 'NAME' | translate }}"></kendo-grid-column>
      <kendo-grid-column *ngIf="revenueManager" field="contactName" [width]="20"
        title="{{ 'CONTACT-NAME' | translate }}"></kendo-grid-column>
      <kendo-grid-column *ngIf="revenueManager" field="contactPhone" title="{{ 'CONTACT-PHONE' | translate }}"
        [width]="20">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{dataItem.contactPhone | phone}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column *ngIf="revenueManager" field="contactEmail" [width]="20"
        title="{{ 'CONTACT-EMAIL' | translate }}">
      </kendo-grid-column>
      <kendo-grid-column *ngIf="revenueManager" field="invoiceNumberSuffix" [width]="20"
        title="{{ 'INVOICE-NUMBER-SUFFIX' | translate }}"></kendo-grid-column>
      <kendo-grid-column *ngIf="revenueManager" field="feeSchedules" [width]="25"
        title="{{ 'FEE-SCHEDULE' | translate }}" class="ellipsis-text" [sortable]="false" [filterable]="false">
      </kendo-grid-column>
      <kendo-grid-column class="text-center" field="active" [width]="10" title="{{ 'ENABLED' | translate }}"
        filter="boolean">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i *ngIf="dataItem.active" class="fas fa-check"></i>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="lastModifiedBy" [width]="15" title="{{ 'LAST-MODIFIED-BY' | translate }}">
      </kendo-grid-column>
      <kendo-grid-column field="lastModifiedOn" [width]="15" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
        filter="date" format="{0:g}"></kendo-grid-column>
      <kendo-grid-command-column [width]="10" title="{{ 'ACTIONS' | translate }}" class="text-center">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])">
          </i>
          &nbsp;
          <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}" (click)="deleteHandler(dataItem['id'])">
          </i>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
    <button kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3" (click)="addHandler()">
      {{'ADD' | translate}}<i class="far fa-plus"></i>
    </button>
  </div>
</div>

<!--Add/Edit form-->
<app-insurer-edit [model]="editDataItem" [isNew]="isNew" [revenueManager]="revenueManager"
  (save)="saveChangesHandler($event)" (cancelling)="cancelChangesHandler()">
</app-insurer-edit>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
  [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-DELETION' | translate }}</p>
  <span class="k-font-weight-bold">{{selectedInsurer.name}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate
      }}</button>
  </kendo-dialog-actions>
</kendo-dialog>